{
  "settings": "Instellingen",
  "yourDigitalAssistant": "Uw digitale assistent",
  "getStarted": "Beginnen",
  "login": "Log in",
  "loggingIn": "Inloggen ...",
  "darkMode": "Donkere modus",
  "clearHistory": "Geschiedenis wissen",
  "historyCleared": "Geschiedenis gewist",
  "changeLanguage": "Taal",
  "termsAndConditions": "Algemene voorwaarden",
  "messagePlaceholder": "Schrijf je bericht hier ...",
  "messagePlaceholderDisabled": "Typen uitgeschakeld ...",
  "feedbackTitle": "Beoordeel uw ervaring",
  "feedbackPlaceholder": "Vertel ons erover (optioneel)",
  "feedbackSend": "Verturen",
  "feedbackClose": "Sluiten",
  "sessionExpired": "Je sessie is verlopen vanwege inactiviteit.",
  "startNewSession": "Start een nieuwe sessie",
  "apiError": "Oeps! Er is iets misgegaan. We werken eraan dit zo snel mogelijk te verhelpen.",
  "apiErrorOffline": "U bent niet verbonden met internet.",
  "tryAgain": "Probeer het opnieuw",
  "startOver": "Begin opnieuw",
  "chatEnded": "Chat is beëindigd.",
  "chatEndedThankYou": "Bedankt voor het chatten met ons!",
  "closeChat": "Dichtbij",
  "startNewChat": "Chat opnieuw",
  "humanTakeoverStarted": "U wordt nu overgedragen aan de klantenservice ...",
  "humanTakeoverQueued": "Wachten op verbinding met een agent",
  "humanTakeoverAnAgent": "Een agent",
  "humanTakeoverAgentEntered": "ging het gesprek aan",
  "humanTakeoverAgentLogout": "verliet het gesprek",
  "humanTakeoverTransfer": "U wordt overgebracht naar een nieuwe agent",
  "humanTakeoverEnded": "U bent nu aan het chatten met uw digitale assistent",
  "version": "Versie",
  "formIntroText": "Vul het volgende formulier in om met ons te chatten.",
  "formFirstName": "Voornaam",
  "formLastName": "Achternaam",
  "formName": "Name",
  "formEmail": "E-mail",
  "formWrongEmail": "Geef een geldig e-mailadres op.",
  "formPhone": "Telefoon",
  "formShipmentId": "Zending-ID",
  "formQuestion": "Uw vraag",
  "formAccountNumber": "Rekeningnummer (voor zakelijke klanten)",
  "formAddress": "Adres",
  "formPostcode": "Postcode",
  "formCity": "Stad",
  "formCountry": "Land",
  "formSubmitButton": "Chat starten",
  "formEmptyFieldError": "Mag niet leeg zijn.",
  "formPhoneNumberValidationError": "Geen geldig telefoonnummer.",
  "formInputIsBiggerThan50": "Mag maximaal 50 tekens bevatten.",
  "formInputIsBiggerThan100": "Mag maximaal 100 tekens bevatten.",
  "formInputIsBiggerThan2000": "Mag maximaal 2000 tekens bevatten.",
  "widgetEventOnline": "DA-bericht: gebruiker is weer online.",
  "widgetEventHidden": "DA-bericht: Widget is verborgen.",
  "widgetEventVisible": "DA-bericht: widget is zichtbaar.",
  "widgetEventVisibleMinimized": "DA-bericht: Widget is zichtbaar, maar geminimaliseerd.",
  "widgetEventMinimized": "DA-bericht: widget is geminimaliseerd.",
  "widgetEventMaximized": "DA-bericht: widget is gemaximaliseerd.",
  "widgetEventSessionExpired": "DA-bericht: widgetsessie is verlopen.",
  "widgetEventHangupHuman": "DA-bericht: Gebruiker beëindigt menselijke overnamesessie.",
  "widgetEventUserTyping": "DA-bericht: gebruiker is aan het typen.",
  "fileTooLarge": "U probeert te grote bestanden bij te voegen.",
  "tooManyDiles": "U probeert te veel bestanden bij te voegen.",
  "fileInvalidType": "U probeert ongeldige bestandstypen toe te voegen.",
  "attachmentsDropHere": "Zet hier neer om te uploaden of",
  "attachmentsBrowse": "Bestanden doorbladeren",
  "attachmentsExtenstionQuantity": "pdf of afbeeldingen (maximaal 10 bestanden)",
  "attachmentsSize": "maximaal 30 MB",
  "attachmentsFailedUploading": "Uploaden mislukt",
  "attachmentsUploading": "Bezig met uploaden ...",
  "minimizeExpandText": "Livechat nu met ons!",
  "popupWidgetNotificationMessage": "Je hebt een nieuw bericht ontvangen!",
  "tabWidgetNotificationMessage": "Nieuw bericht!",
  "datepickerSendButton": "Versturen"
}
